import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useUserUpdateMutation = () => {
  return useMutation({
    mutationFn: api.user.updateUser,
  });
};

export default useUserUpdateMutation;
